import { render, staticRenderFns } from "./GzzjwhForm.vue?vue&type=template&id=90ca0938&scoped=true"
import script from "./GzzjwhForm.vue?vue&type=script&lang=js"
export * from "./GzzjwhForm.vue?vue&type=script&lang=js"
import style0 from "./GzzjwhForm.vue?vue&type=style&index=0&id=90ca0938&prod&lang=scss&scoped=true"
import style1 from "./GzzjwhForm.vue?vue&type=style&index=1&id=90ca0938&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ca0938",
  null
  
)

export default component.exports